import { Component, EventEmitter, Input, OnDestroy, Output, Signal, signal, SimpleChanges } from '@angular/core';
import { QuickAddService } from '../../services/quick-add.service';
import { toSignal } from '@angular/core/rxjs-interop';
import { map, catchError, of, Subject, debounceTime, distinctUntilChanged, Observable, Observer, startWith, takeUntil, skip } from 'rxjs';
import { TaskViewModel } from '../../models-views/task.view.model';
import { Project } from '../../models/project.model';
import { ProjectViewModel } from '../../models-views/project.view.model';
 
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NzMessageService } from 'ng-zorro-antd/message';
import { AppCommon } from '../../providers/app-common';
import { NzUploadFile } from 'ng-zorro-antd/upload';
import { ConsoleViewModel } from '../../models-views/console.view.modal';
import { QuillCustomServices } from '../../providers/quill-config';
import { Router } from '@angular/router';

@Component({
  selector: 'app-task-drawer',
  standalone: false,
  templateUrl: './task-drawer.component.html',
  styleUrl: './task-drawer.component.scss',
  providers: [TaskViewModel,ProjectViewModel]
})
export class TaskDrawerComponent  {
  private destroy$ = new Subject<boolean>();
  fileList: NzUploadFile[] = []
  quillConfig:any
  loggedInUser :any
  @Input() isVisible = false;
  @Input() data :any;
  @Output() closeDrawer = new EventEmitter<boolean>();
  searchInput$ = new Subject<string>();
  listOfProject = []
  page:number=1;
  page_size:number=10;
  // Form fields
  listOfTaskStatus = []
  listOfUserGroup = []
  listOfUser = []
  priorityList = []
  // Tagging options for Task Work Notes
  // taggingOptions: string[] = ['@JohnDoe', '@JaneSmith', '@TeamLead'];
  loadingProject = false;
  taskForm :FormGroup
  disabledProject:boolean = false
  userSearchTimeOut:any
  constructor( private quickAddService: QuickAddService, private vmt : TaskViewModel,private vmp:ProjectViewModel,private router: Router,
     private fb : FormBuilder,private message: NzMessageService,private cvm : ConsoleViewModel, private quilservice:QuillCustomServices){
    this.initiatForm()
    this.loggedInUser = AppCommon.getloggedInObject().user
    this.quillConfig = this.quilservice.QuillConfigDefault 
    this.vmt.userList.pipe(takeUntil(this.destroy$)).subscribe((data:any) => {
            this.quilservice.setMentions(data.results)  
    })
  }

  ngOnInit(): void {
    //Called after the constructor, initializing input properties, and the first call to ngOnChanges.
    //Add 'implements OnInit' to the class.

    this.vmt.parentTaskDrawerComponent = this;

    this.vmp.projectListData.subscribe( e =>( this.listOfProject = e.results ,
      this.loadingProject = false, this.setUpTaskProjectSubsciption()));
    this.vmt.userGroupList.subscribe( e => this.listOfUserGroup = e.results );
    this.vmt.taskStatusList.subscribe( e => this.listOfTaskStatus = e.results );
    // Update dropdown whenever user list API returns
    this.vmt.userList.pipe(skip(1)).subscribe( e => {
      this.listOfUser = e.results;
    });
    this.vmt.priorityList.subscribe( e => this.priorityList = e.results );
    
    this.vmt.getTaskStatusList(this.page,this.page_size);
    this.vmp.getProjectList(this.page,500, '', 'task-drawer');
    this.vmt.getUserGroupList(this.page,this.page_size);
    // Do NOT fetch users until a group is selected
    this.vmt.getPriorityList(this.page,this.page_size);
    
     // Listen for changes in the 'website' input field
    
    
    this.searchInput$.pipe(debounceTime(500),distinctUntilChanged()).subscribe( name => 
      this.vmp.getProjectList(this.page,100,name, 'task-drawer'))

    // Fetch users when assigned_to_group changes (pass comma-separated group IDs)
    this.taskForm.get('assigned_to_group')?.valueChanges
      .pipe(takeUntil(this.destroy$))
      .subscribe((groups: number[]) => {
        let csv :any = Array.isArray(groups) && groups.length > 0 ? groups.join(',') : '';
        if (csv) {
          // initial load without name filter
          this.vmt.getUserList(1, 500, '', csv);
        } else {
          // Clear users if no group selected
          this.listOfUser = [];
          this.taskForm.get('assigned_to')?.setValue([], { emitEvent: false });
        }
      });
  }

  ngOnChanges(changes: SimpleChanges): void {
    
    //Called before any other lifecycle hook. Use it to inject dependencies, but avoid any serious work here.
    //Add '${implements OnChanges}' to the class.
    if(this.data && changes['data'].currentValue){
    
     let formData = {
        task_project:changes['data'].currentValue.task_project,
        name:changes['data'].currentValue.name,
        priority: changes['data'].currentValue.priority,
        due_date: changes['data'].currentValue.due_date,
        description	: changes['data'].currentValue.description,
        task_status: changes['data'].currentValue.task_status,
        assigned_to: changes['data'].currentValue.assigned_to,
        assigned_to_group: changes['data'].currentValue.assigned_to_group,
        additional_files: changes['data'].currentValue.additional_files
      }
      this.taskForm.patchValue(formData)
      this.disabledProject = true;
      changes['data'].currentValue?.additional_files_details && (this.fileList = changes['data'].currentValue?.additional_files_details.map(file => ({
        uid: file.id,
        name: file.name,
        status: 'done',
        url: file.file
      })))

      // When editing, fetch users for the assigned groups so they show as selected in dropdown
      let assignedGroups: number[] = changes['data'].currentValue.assigned_to_group || [];
      if (Array.isArray(assignedGroups) && assignedGroups.length > 0) {
        let groupsCsv :any= assignedGroups.join(',');
        // console.log('Fetching users for groups during edit:', groupsCsv);
        this.vmt.getUserList(1, 500, '', groupsCsv);
      }
    }

  }

  ngOnDestroy(): void {
    //Called once, before the instance is destroyed.
    //Add 'implements OnDestroy' to the class.
    // localStorage.removeItem('selectedProject');
    this.destroy$.next(true);
    this.destroy$.complete();
  }

  initiatForm(){
    // Form Group
 
   this.taskForm = this.fb.group({
    task_project: [ sessionStorage.getItem('selectedProject') ? Number(sessionStorage.getItem('selectedProject')) : null , Validators.required],
    hardCostCap: [{ value: '', disabled: true }],
    name: ['', [Validators.required,Validators.maxLength(200)]],
    priority: ['', Validators.required],
    due_date: ['', Validators.required],
    description	: ['', Validators.required, ],
    task_status: [1, Validators.required],
    assigned_to: [[]],
    assigned_to_group: [[],Validators.required],
    additional_files: [[]]
  });
  }

  // Disable dates before today for the due date picker
  disabledPastDate = (current: Date): boolean => {
    if (!current) return false;
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const d = new Date(current);
    d.setHours(0, 0, 0, 0);
    return d < today;
  };

  open() {
    this.isVisible = true;
  }

  

  setUpTaskProjectSubsciption(){
     this.taskForm.get('task_project')?.valueChanges.pipe(
        startWith(this.taskForm.get('task_project')?.value),
     ).subscribe((value) => {
      if (value) {
      
        // Remove 'https://' from the input value
        const sanitizedValue = this.listOfProject?.filter( e => e.id == value)[0]?.project_cost.toString();
        // Update the form control with the sanitized value
        this.taskForm.get('hardCostCap')?.setValue(sanitizedValue, { emitEvent: false });
        
      }
    });
  }

  onSearchMember(e:any){
    clearTimeout(this.userSearchTimeOut)
    this.userSearchTimeOut = setTimeout(() => {
      const groups: number[] = this.taskForm.get('assigned_to_group')?.value || [];
      let csv:any = Array.isArray(groups) && groups.length > 0 ? groups.join(',') : '';
      // Only search when there is a selected group context
      if (csv) {
        const name = (e || '').trim();
        this.vmt.getUserList(1, 500, name, csv);
      }
      } , 400 )
  }

  onSearchProject(e:any){
    this.loadingProject = true
    this.searchInput$.next(e.trim())
  }

  customUploadRequest = (item: any) => {
   return  this.vmt.uploadMediaFile(item, this.loggedInUser.id)
  };

  onUploadChange(event: any): void {
    // console.log('Upload Event:', event);
    if (event.type === 'success') {
      this.taskForm.get('additional_files')?.setValue( [...this.taskForm.get('additional_files').value ,event.file.response.id], { emitEvent: false });
      // console.log('File uploaded successfully:', event.file);
    } else if (event.type === 'error') {
      console.error('File upload failed:', event.file);
    } else if(event.type == 'removed'){ 
      this.fileList = this.fileList.filter(f => f.uid !== event.file.uid);
      this.taskForm.get('additional_files')?.setValue( [...this.fileList ], { emitEvent: false });
      // this.vmt.deleteMediaFile(event.file.uid)
    }
    
    
    // console.log(this.taskForm.value , event.file.response.id)
  }

  close(): void {
    this.isVisible = false;
    this.taskForm.reset();
    this.closeDrawer.emit(false); 
    this.quickAddService.refreshData.next(true);
  }

  closeonly(){ 
    this.isVisible = false;
    this.taskForm.reset();
    this.closeDrawer.emit(false);
  }

  beforeUpload = (file: NzUploadFile, _fileList: NzUploadFile[]): Observable<boolean> => 
    new Observable((observer: Observer<boolean>) => {
        const isLt5M = file.size! / 1024 / 1024 < 5;
        if (!isLt5M) {
            this.message.error(`${file.name} is larger than 5MB!`);
            observer.next(false); // Emit false to indicate validation failed
            observer.complete();
        } else {
            observer.next(true); // Emit true to indicate validation passed
            observer.complete();
        }
    });

  submitTaskForm() {
      if (this.taskForm.valid) {
        let formValue = this.taskForm.value
        // console.log('Form submitted:', this.taskForm.value);
        // Handle form submission
        if(this.data){
          formValue['modified_by'] = this.loggedInUser.id;
          this.vmt.updateTask(formValue , this.data?.id, 'task-drawer')
        } else{
          formValue['created_by'] = this.loggedInUser.id;
          this.vmt.createTask(formValue);
        }
       
        // this.close();
      } else {
        this.message.error('Please fill all required fields correctly');
        Object.values(this.taskForm.controls).forEach(control => {
          if (control.invalid) {
            control.markAsDirty();
            control.updateValueAndValidity({ onlySelf: true });
          }
        });
      }
    }


    errorCreateUpdate(){

    }

    successCreateUpdate(e){
      this.close();
       setTimeout(() => {
        this.router.navigate(['app/tasks' , e.id])
      },1000)
    }
    
     onAssignToDropdownChange(isOpen: boolean) {
    if (!isOpen) {
      // Clear the dropdown data when dropdown closes
      this.listOfUser = [];
    }
  }

}
